import { Box, Typography } from '@mui/material';

const MinMaxMessage = ({ message, 'data-testid': testId }) => {
  return (
    <Box fontWeight="bold" data-testid={testId}>
      <Typography>{message}</Typography>
    </Box>
  );
};

export default MinMaxMessage;
